import type { ReactNode } from 'react';
import { AlertTriangle, Check, Info, X } from 'react-feather';

export type CredoraToastType = 'success' | 'error' | 'warning' | 'info';

const TOAST_META: Record<
  CredoraToastType,
  { icon: ReactNode; label: string }
> = {
  success: { icon: <Check size={20} />, label: 'Success' },
  error: { icon: <X size={20} />, label: 'Error' },
  warning: { icon: <AlertTriangle size={20} />, label: 'Warning' },
  info: { icon: <Info size={20} />, label: 'Info' },
};

export function CredoraToastContent({
  type = 'info',
  message,
}: {
  type?: CredoraToastType;
  message: string;
}) {
  const meta = TOAST_META[type] ?? TOAST_META.info;

  return (
    <div className={`credora-toast__content credora-toast__content--${type}`}>
      <span className={`credora-toast__icon credora-toast__icon--${type}`} aria-hidden>
        {meta.icon}
      </span>
      <div className="credora-toast__text">
        <span className="credora-toast__label">{meta.label}</span>
        <p className="credora-toast__message mb-0">{message}</p>
      </div>
    </div>
  );
}
